import {useState} from "react";
import {useKeepFilters} from "../utils/form-utils";

export function useFilters<T extends Record<string, any>>(initialState: T, initializeKeepParams?: string[]) {

    const {searchParams, setFilterParameter} = useKeepFilters();

    const initialFilters = { ...initialState };

    initializeKeepParams?.forEach((key) => {
        const value = searchParams.get(key);
        if (value !== null) {
            initialFilters[key as keyof T] = value as any;
        }
    });

    const [filters, setFilters] = useState<T>(
        initialFilters
    );


    const updateFilter = (key: keyof T, value: any) => {
        setFilters((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const updateFilterKeepingParam = (key: keyof T, value: any) => {
        setFilterParameter(key as string, value);
        setFilters((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const resetFilters = () => setFilters(initialState);

    return { filters, updateFilter, updateFilterKeepingParam, resetFilters };
}
